<dx-popup class="popup" [width]="800" [height]="450" [showTitle]="true" [title]="title" [closeOnOutsideClick]="true"
    [(visible)]="show" style="padding:0px" (onShowing)="whenShowing()">
    <div *dxTemplate="let data of 'content'" style="padding:0px">        
            <div style="display: inline-block;width:300px">
                <dx-tree-view 
                    #tree 
                    id="simple-treeview" 
                    [searchEnabled]="true" 
                    searchMode="contains" 
                    [items]="list"
                    [height]="300" 
                    (onItemClick)="selectItem($event)"></dx-tree-view>
            </div>
            <div style="display: inline-block;width:400px;vertical-align: top;padding-left: 30px;height: 300px;">                
                <dx-scroll-view [showScrollbar]="always">
                    <pump-set-detail *ngIf="lastSelected && lastSelected.id && context=='Pumpset'" [isUserPumpSet]="lastSelected.isUser" [pumpSetDetailId]="lastSelected.id" ></pump-set-detail>                
                    <app-booster-detail *ngIf="lastSelected && lastSelected.id && context=='Booster'" [boosterId]="lastSelected.id"></app-booster-detail>
                </dx-scroll-view>                
            </div>        
        <div>
        <dx-button text="Select" style="margin-top: 10px;" (onClick)="select()" [disabled]="!selectEnabled"></dx-button>
        <dx-button text="Cancel" style="margin-top: 10px;margin-left: 10px;" (onClick)="cancel()"></dx-button>
        </div>    
    </div>
</dx-popup>